
// import React from 'react';
// import BlogHome from './BlogHome';
// import Category from './Category';
// import CategoryFilter from './CategoryFilter';

// function BlogComponent() {

//   return (
//     <div className="flex justify-center items-start h-screen">
//       <BlogHome/>
//       <div className="flex w-full max-w-6xl">
        
//         {/* Sidebar - 30% width */}
//         <div className="w-2/3 p-4">
//           <Category/>
//         </div>

//         {/* Main Content - 70% width */}
//         <div className="w-1/3 p-4">
//      <CategoryFilter/> 
//         </div>
//       </div>
//     </div>
//   );
// }
// export default BlogComponent;


import React from 'react';
import BlogHome from './BlogHome';
import Category from './Category';
import CategoryFilter from './CategoryFilter';

function BlogComponent() {
  return (
    <div className="flex flex-col items-center  ">
      {/* BlogHome - Full Width */}
      <div className="w-full">
        <BlogHome />
      </div>

      {/* Container for Category and CategoryFilter */}
      <div className="flex w-full mt-4">
        
        {/* Sidebar - 30% width */}
        <div className="w-2/3  m-8">
          <Category />
        </div>

        {/* Main Content - 70% width */}
        <div className="w-1/3 m-8">
          <CategoryFilter />
        </div>
      </div>
    </div>
  );
}

export default BlogComponent;
